import type { CSSProperties } from 'react'

export type AreaChartPoint = {
  /** Optional category / x label. */
  label?: string
  /** Numeric value plotted on the Y axis (higher = nearer the top). */
  value: number
}

export const AREA_CHART_DEFAULT_WIDTH = 680
export const AREA_CHART_DEFAULT_HEIGHT = 220
export const AREA_CHART_DEFAULT_STROKE_WIDTH = 2

/** Figma stroke — cyan/cyan-400. */
export const AREA_CHART_STROKE_COLOR = 'var(--ds-cyan-400)'

/** Figma fill — cyan/cyan-100 at 40% opacity. */
export const AREA_CHART_FILL_COLOR = 'var(--ds-cyan-100)'
export const AREA_CHART_FILL_OPACITY = 0.4

/**
 * Default series matching Figma Vector 112 / 113
 * (y inverted from path coords in a 220px-tall frame).
 */
export const AREA_CHART_DEFAULT_DATA: AreaChartPoint[] = [
  { value: 220 },
  { value: 77 },
  { value: 129 },
  { value: 104 },
  { value: 157 },
  { value: 105 },
]

export type AreaChartProps = {
  /** Series values. Defaults to the Figma demo path. */
  data?: AreaChartPoint[]
  /** Chart width in px. Defaults to 680. */
  width?: number
  /** Chart height in px. Defaults to 220. */
  height?: number
  /** Line stroke color. */
  strokeColor?: string
  /** Area fill color. */
  fillColor?: string
  /** Area fill opacity (0–1). Defaults to 0.4. */
  fillOpacity?: number
  /** Line stroke width. Defaults to 2. */
  strokeWidth?: number
  /**
   * Y-axis ceiling. Defaults to the max data value (or 1 when empty).
   * Pass an explicit max to keep scale stable across datasets.
   */
  maxValue?: number
  /**
   * Y-axis floor. Defaults to 0.
   */
  minValue?: number
  /**
   * Show nearest-point hover tooltip (Dashboard / Reports style).
   * Defaults to `true`.
   */
  showTooltip?: boolean
  /** Series name shown in the tooltip. Defaults to "Value". */
  seriesName?: string
  /** Format tooltip numeric values. Defaults to String(value). */
  formatValue?: (value: number) => string
  /** Dark surface — adjusts tooltip chrome. */
  darkMode?: boolean
  className?: string
  style?: CSSProperties
  'aria-label'?: string
}
